<h2 class="text-head">ผลการค้นหา</h2>
<div class="mat-elevation-z8 example-container" id="resual_search" *ngIf="dataSource !== undefined">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="no">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let index = index"> {{index+1}}</td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>ชื่อสินค้า</th>
            <td mat-cell *matCellDef="let element">{{element.name}}</td>
        </ng-container>
        <ng-container matColumnDef="front_store_price">
            <th mat-header-cell *matHeaderCellDef class="th-rigth">ราคาหน้าร้าน</th>
            <td mat-cell *matCellDef="let element" class="th-rigth">{{element.front_store_price}}</td>
        </ng-container>
        <ng-container matColumnDef="unit">
            <th mat-header-cell *matHeaderCellDef class="td-conten-center">หน่วย</th>
            <td mat-cell *matCellDef="let element" class="td-conten-center">{{element.unit_type}}</td>
        </ng-container>
        <ng-container matColumnDef="wholesale_price">
            <th mat-header-cell *matHeaderCellDef class="th-rigth">ราคาส่ง</th>
            <td mat-cell *matCellDef="let element" class="th-rigth">{{element.wholesale_price | number:'.2'}}</td>
        </ng-container>
        <ng-container matColumnDef="choose">
            <th mat-header-cell *matHeaderCellDef class="th-rigth">ตัวเลือก</th>
            <td mat-cell *matCellDef="let element" class="th-rigth">
                <a>
                    <mat-icon aria-hidden="false" aria-label="add icon" (click)="addToBasket(element.barcode)">add
                    </mat-icon>
                </a>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsSearch"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsSearch;"></tr>
    </table>
    <mat-paginator [pageSize]="5"></mat-paginator>
    {{errorText}}
</div>